import { render, staticRenderFns } from "./UnitProductPage.vue?vue&type=template&id=2fdf2732&scoped=true"
import script from "./UnitProductPage.vue?vue&type=script&lang=js"
export * from "./UnitProductPage.vue?vue&type=script&lang=js"
import style0 from "./UnitProductPage.vue?vue&type=style&index=0&id=2fdf2732&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdf2732",
  null
  
)

export default component.exports